import baseApi from "./baseApi"
import momentCache from '@/services/momentCache'

export default  {
    async getPlantData() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/forecasting/plants");

        return result.data.map(mapPlantData);
    },
    async getWeatherData(plantId, startDate, endDate){
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/forecasting/getPlantWeather?${[
            `PlantID=${plantId}`,
            `StartDate=${momentCache.getMoment(startDate).format('YYYY-MM-DD')}`,
            `EndDate=${momentCache.getMoment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);

        return result.data.map(mapWeatherData);
    },
    async getFinancialYearCalendarsData() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/forecasting/financialYearCalendar`);

        return result.data.map(mapFinancialYearCalendar);
    },
    async getCropVarietyData(plantId, categoryId, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.get(`/forecasting/cropVarieties?${[
            `PlantID=${plantId}`,
            `ProductCategoryID=${categoryId}`,
            `StartDate=${momentCache.getMoment(startDate).format('YYYY-MM-DD')}`,
            `EndDate=${momentCache.getMoment(endDate).format('YYYY-MM-DD')}`
        ].join("&")}`);

        let { Crops, Varieties, Forecasts, Notes, YieldPredictions, NuPointSprays } = result.data;

        return {
            crops: Crops.map(mapCrop),
            varieties: Varieties.map(mapVariety),
            forecasts: Forecasts.map(mapForecast),
            yields: YieldPredictions.map(mapYields),
            notes: Notes.map(mapNote),
            nuPointSprays: NuPointSprays.map(mapNuPointSpray)
        };
    },
    async updateForecasts(forecasts, fetchAll, plantId, categoryId, startDate, endDate) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/forecasting/updateForecastValues`, {
            Forecasts: forecasts.map(x => {
                return {
                    CropLocationID: x.cropLocationId,
                    ProductVarietyID: x.varietyId,
                    ForecastDate: momentCache.getMoment(x.forecastDate).format('YYYY-MM-DD'),
                    ForecastValue: x.forecastValue,
                    AdjustedValue: x.adjustedValue
                };
            }),
            FetchAll: fetchAll,
            PlantID: plantId,
            ProductCategoryID: categoryId,
            StartDate: startDate,
            EndDate: endDate
        });

        return result.data.map(x => mapForecast(x));
    },
    async updateForecast(cropLocationId, varietyId, date, forecastValue, adjustedValue) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/forecasting/updateForecastValue`, {
            CropLocationID: cropLocationId,
            ProductVarietyID: varietyId,
            ForecastDate: momentCache.getMoment(date).format('YYYY-MM-DD'),
            ForecastValue: forecastValue,
            AdjustedValue: adjustedValue
        });

        return mapForecast(result.data);
    },
    async updateCropVariety(variety) {
        let request = await baseApi.createHttpRequest();
        let result = await request.post(`/forecasting/UpdateCropVariety`, mapVarietyModel(variety));

        return mapVariety(result.data);
    },
    async addUpdateNotes(notes) {
        let request = await baseApi.createHttpRequest();
        
        let result = await request.post(`/forecasting/addUpdateNotes`, notes.map(mapNoteModel));
        return result.data.map(mapNote);
    },
    async uploadNotePhoto(photo) {
        let request = await baseApi.createHttpRequest();
        let data = new FormData();
        var photoModel = mapPhotoModel(photo);
        data.set("json", JSON.stringify(photoModel));
        data.set("photo", JSON.stringify(photo.photoBlob));
        data.set(JSON.stringify("photo"), photo.photoBlob);
        let result = await request.post("/forecasting/uploadNotePhoto", data, {
            headers: {
                "Content-Type": "multipart/form-data; boundary=" + data._boundary
            }
        });
        return result.data;
    },
    async getNoteAlertCategories() {
        let request = await baseApi.createHttpRequest();
        let result = await request.get("/forecasting/noteAlertCategories");

        return result.data.map(mapNoteAlertCategoryData);
    },
    async exportForecastReport(plantID, productCategoryID, divisionIds, varietyIds, startDate, endDate) {
        let request = await baseApi.createHttpRequest("blob");
        let result = await request.get("/forecasting/export?" + [
            "PlantID=" + plantID,
            "ProductCategoryID=" + productCategoryID,
            "divisionIDs=" + divisionIds.join(','),
            "VarietyIDs=" + varietyIds.join(','),
            "StartDate="+startDate,
            "EndDate="+endDate

        ].join("&"));

       return result;
    }
}

function mapPlantData(x){
    return {
        plantId: x.PlantID,
        plantName: x.PlantName,
        productCategories: x.ProductCategories.map(mapProductCategory),
        Region: x.Region
    };
}

function mapProductCategory(x){
    return {
        productCategoryId: x.ProductCategoryID,
        productCategoryName: x.ProductCategoryName,
        defaultUOM: x.DefaultUOM,
        defaultPlantUnit: x.DefaultPlantUnit != null ? {
            plantUnitID: x.DefaultPlantUnit.PlantUnitID,
            aveKgsPerUnit: x.DefaultPlantUnit.AveKgsPerUnit,
            numInTray: x.DefaultPlantUnit.NumInTray
        } : null
    }
}

function mapWeatherData(x){
    return {
        plantId: x.PlantID,
        summary: x.Summary,
        icon: x.Icon,
        temperatureDate: x.TemperatureDate,
        temperatureMax: x.TemperatureMax,
        temperatureMin: x.TemperatureMin,
        humidity: x.Humidity
    };
}

function mapFinancialYearCalendar(x) {
    return {
        financialYear: x.FinancialYear,
        startDate: momentCache.getMoment(x.StartDate.substring(0, 10)).format('YYYY-MM-DD')
    }
}

function mapCrop(x){
    return {
        plantId: x.PlantID,
        productCategoryId: x.ProductCategoryID,
        cropLocationId: x.CropLocationID,
        divisionId: x.DivisionID,
        divisionName: x.DivisionName,
        locationId: x.LocationID,
        locationName: x.LocationName,
        productCategory: x.ProductCategory,
        productType: x.ProductType,
        cropCode: x.CropCode,
        cropStartDate: momentCache.getMoment(x.CropStartDate.substring(0, 10)).format('YYYY-MM-DD'),
        cropEndDate: momentCache.getMoment(x.CropEndDate.substring(0, 10)).format('YYYY-MM-DD'),
        cropArea: x.CropArea,
        totalNumberOfRows: x.TotalNumberOfRows,
        totalNumberOfBushes: x.TotalNumberOfBushes
    };
}

function mapVariety(x){
    return {
        cropLocationId: x.CropLocationID,
        locationId: x.LocationID,
        varietyId: x.VarietyID,
        varietyName: x.VarietyName,
        varietyDescription: x.VarietyDescription,
        nextPickDate: momentCache.getMoment(x.NextPickDate.substring(0, 10)).format('YYYY-MM-DD'),
        nextPickDateMovedDays: x.NextPickDateMovedDays,
        nextPickDateWithoutRotation: momentCache.createMoment(x.NextPickDate.substring(0, 10)).add((x.RotationDays || 0) * -1, 'days').format('YYYY-MM-DD'),
        rotationDays: x.RotationDays,
        lastPickActualValue: x.LastPickActualValue,
        manualNextPickDate: x.ManualNextPickDate == null ? null : momentCache.getMoment(x.ManualNextPickDate.substring(0, 10)).format('YYYY-MM-DD'),
        activeProfile: x.ActiveProfile ? mapProfile(x.ActiveProfile, x) : {}
    };
}

function mapVarietyModel(x) {
    return {
        CropLocationId: x.cropLocationId,
        VarietyId: x.varietyId,
        VarietyName: x.varietyName,
        VarietyDescription: x.varietyDescription,
        NextPickDate: x.nextPickDate,
        NextPickDateMovedDays: x.nextPickDateMovedDays,        
        RotationDays: x.rotationDays,
        LastPickActualValue: x.lastPickActualValue,
        ManualNextPickDate: x.manualNextPickDate,
        ActiveProfile: x.activeProfile
    };
}

function mapProfile(x, variety) {
    return {
        BerriesForecastProfileID: x.BerriesForecastProfileID,
        VarietyID: x.VarietyID,
        Variety: {
            VarietyID: x.VarietyID,
            VarietyName: variety.VarietyName,
            VarietyDescription: variety.VarietyDescription
        },
        PlantID: x.PlantID,
        DivisionID: x.DivisionID,
        BerriesPlantAgeID: x.BerriesPlantAgeID,
        BerriesCroppingSystemID: x.BerriesCroppingSystemID,
        StartWeek: x.StartWeek,
        TonnesPerHectare: x.TonnesPerHectare,
        CropLocationID: x.CropLocationID,
        StartYear: x.StartYear,
        IsActive: x.isActive,
        CropArea: x.CropArea,
        BudgetValues: x.BudgetValues.map(mapBudgetValue)
    }
}

function mapBudgetValue(x) {
    return {
        BerriesForecastProfileValueID: x.BerriesForecastProfileValueID,
        BerriesForecastProfileWeekNumber: x.BerriesForecastProfileWeekNumber,
        BudgetValue: x.BudgetValue
    }
}

function mapForecast(x){
    return {
        cropLocationId: x.CropLocationID,
        varietyId: x.VarietyID,
        forecastDate: momentCache.getMoment(x.ForecastDate.substring(0, 10)).format('YYYY-MM-DD'),
        forecastValue: x.ForecastValue,
        adjustedValue: x.AdjustedValue,
        actualValue: x.ActualValue,
        isSpray: x.IsSpray,
        hasRoster: x.HasRoster
    };
}

function mapYields(x) {
    return {
        yieldPredictionID: x.YieldPredictionID,
        plantId: x.PlantID,
        locationId: x.LocationID,
        productCategoryId: x.ProductCategoryID,
        varietyId: x.VarietyID,
        financialWeek: x.FinancialWeek,
        financialYear: x.FinancialYear,
        yieldValue: x.YieldValue
    };
}

function mapPhotoModel(x){
    return {
        BerriesForecastNoteID: x.berriesForecastNoteId,
        UploadedAt: x.uploadedAt,
        UploadedBy: x.uploadedBy,
        UploadedByName: x.uploadedByName,
        PhotoName: x.photoName,
        PhotoMimeType: x.photoMimeType,
        PhotoExtension: x.photoExtension
    }
}

function mapNote(x){
    return {
        berriesForecastNoteId: x.BerriesForecastNoteID,
        cropLocationId: x.CropLocationID,
        varietyId: x.VarietyID,
        berriesForecastNoteAlertCategoryId: x.BerriesForecastNoteAlertCategoryID,
        categoryName: x.CategoryName,
        raisedBy: x.RaisedBy,
        raisedByName: x.RaisedByName,
        raisedAt: x.RaisedAt, 
        closedBy: x.ClosedBy,
        closedByName: x.ClosedByName,
        closedAt: x.ClosedAt,
        details: x.Details,
        comments: x.Comments,
        alertLevel: x.AlertLevel,
        isClosed: x.IsClosed,
        photos: x.Photos.map(mapPhoto)
    };
}

function mapNuPointSpray(x) {
    return {
        LocationID: x.LocationID,
        NuPointSprayDate: momentCache.getMoment(x.NuPointSprayDate.substring(0, 10)).format('YYYY-MM-DD'),
        Withholding: x.Withholding,
        WitholdingTo: x.WitholdingTo,
        WithholdColour: x.WithholdColour,
        ICA: x.ICA,
        ICAProtected: x.ICAProtected,
        ICAProtectedFrom: x.ICAProtectedFrom,
        ICAProtectedTo: x.ICAProtectedTo,
        ICAColour: x.ICAColour
    }
}

function mapNoteModel(x) {
    return {
        BerriesForecastNoteID: x.berriesForecastNoteId,
        CropLocationID: x.cropLocationId,
        VarietyID: x.varietyId,
        BerriesForecastNoteAlertCategoryID: x.berriesForecastNoteAlertCategoryId,
        CategoryName: x.categoryName,
        RaisedBy: x.raisedBy,
        RaisedByName: x.raisedByName,
        RaisedAt: x.raisedAt,
        ClosedBy: x.closedBy,
        ClosedByName: x.closedByName,
        ClosedAt: x.closedAt,
        Details: x.details,
        Comments: x.comments,
        AlertLevel: x.alertLevel,
        IsClosed: x.isClosed,
        Photos: x.photos.map(mapPhotoModel)
    }; 
}


function mapPhoto(x){
    return {
        berriesForecastNoteId: x.BerriesForecastNoteID,
        uploadedAt: x.UploadedAt,
        uploadedBy: x.UploadedBy,
        uploadedByName: x.UploadedByName,
        photoName: x.PhotoName
    }
}

function mapNoteAlertCategoryData(x){
    return {
        berriesForecastNoteAlertCategoryId: x.BerriesForecastNoteAlertCategoryID,
        categoryName: x.CategoryName,
        description: x.Description,
        active: x.Active
    };
}


// function mapNoteAlertCategoryModel(x){
//     return {
//         BerriesForecastNoteAlertCategoryID: x.berriesForecastNoteAlertCategoryID,
//         CategoryName: x.categoryName,
//         Active: x.active
//     };
// }